"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/init/init.module.ts');
const router_1 = require("@angular/router");
const init_db_component_1 = require("./init-db.component");
const init_licence_component_1 = require("./init-licence.component");
const init_component_1 = require("./init.component");
const init_account_component_1 = require("./init-account.component");
const AppRouting = [
    {
        path: '', component: init_component_1.InitComponent,
        children: [
            { path: '', redirectTo: "db", pathMatch: 'full' },
            { path: "db", component: init_db_component_1.InitDBComponent, pathMatch: 'full' },
            { path: "licence", component: init_licence_component_1.InitLicenceComponent, pathMatch: 'full' },
            { path: "account", component: init_account_component_1.InitAccountComponent, pathMatch: 'full' }
        ]
    }
];
class InitModule {
}
exports.InitModule = InitModule;
